/**
 * reducer method to reduce array of products to a [low, high] price range array
 * @param {object} previous product
 * @param {object} current product
 *
 * @returns {array} [low, high]
 */
export function reducePriceRange (previous, current) {
  let cents = current.prices.reduce((a, b) => {
    a.push(b.price_cents)
    return a
  }, [])
  let max = Math.max(...cents)
  let min = Math.min(...cents)

  previous[0] = Math.min(previous[0], min, max)
  previous[1] = Math.max(previous[1], min, max)
  return previous
}

/**
 * Search product for specific value
 *
 * @param {object} obj - Product
 * @param {string} value - search term
 *
 * @returns {boolean} - true if the value exists in the product
 */
export function productHasSearchValue (product, value) {
  value = value.toLowerCase()
  const searchKeys = ['description', 'name', 'brand', 'strain']
  let match = false

  searchKeys.forEach(v => {
    if (product.hasOwnProperty(v) && product[v]) {
      if (product[v].toLowerCase().includes(value)) {
        match = true
      }
    }
  })

  return match
}

/**
 * Flip the order of a sort value if DESC
 *
 * @param {int} result sort result value (1, -1, 0)
 * @param {int} dir 1 for ASC -1 for DESC
 *
 * @returns {int} flipped result value for DESC
 */
export function sortDirection (result, dir) {
  if (result === 0) {
    return result
  }

  return result * dir
}

/**
 * Sort product by lowest THC value
 *
 * @param {object} a product
 * @param {object} b product
 */
export function sortByTHC (a, b) {
  return a.thc.low - b.thc.low
}

/**
 * Sort product by lowest CBD value
 *
 * @param {object} a product
 * @param {object} b product
 */
export function sortByCBD (a, b) {
  return a.cbd.low - b.cbd.low
}

/**
 * Sort product by lowest Price cents value
 *
 * @param {object} a product
 * @param {object} b product
 */
export function sortByPrice (a, b) {
  return a.prices[0].price_cents - b.prices[0].price_cents
}

/**
 * Sort product by specific field stirng value
 *
 * @param {object} a product
 * @param {object} b product
 */
export function sortByField (a, b, field) {
  let result = 0

  if (a.hasOwnProperty(field) && b.hasOwnProperty(field)) {
    if (!a[field]) {
      return 1
    } else if (!b[field]) {
      return -1
    } else if (a[field] < b[field]) {
      result = -1
    } else if (a[field] > b[field]) {
      result = 1
    }
  }

  return result
}

/**
 * Reducer helper to filter products by specific values
 *
 * @param {object} product product to check filter mathc
 * @param {object} filters Active filters
 *
 * @returns {boolean} - true if filters match
 */
export function productHasFilterValues (product, filters) {
  let match = true

  if (filters.priceRange.length === 2) {
    const prices = product.prices.filter(price => {
      return (
        price.price_cents / 100 >= filters.priceRange[0] &&
        price.price_cents / 100 <= filters.priceRange[1]
      )
    })

    if (prices.length <= 0) {
      match = false
    }
  }

  if (filters.strain.length) {
    if (!filters.strain.includes(product.strain)) {
      match = false
    }
  }

  if (filters.brand.length) {
    if (!filters.brand.includes(product.brand)) {
      match = false
    }
  }

  return match
}
